export function resolveAuthorizedProgramSiteId(selectedSiteId, siteIds = []) {
    // A single-site user never needs to manage site context. Prefer the sole current
    // authorization even when browser storage still contains an older selection.
    if (siteIds.length === 1) return String(siteIds[0]);

    if (
        selectedSiteId === null ||
        selectedSiteId === undefined ||
        selectedSiteId === ''
    ) {
        return null;
    }

    const selected = String(selectedSiteId);
    return siteIds.some((siteId) => String(siteId) === selected)
        ? selected
        : null;
}

export function normalizeAuthorizedSiteSelection(selectedSiteId, siteIds = []) {
    if (
        selectedSiteId === null ||
        selectedSiteId === undefined ||
        selectedSiteId === ''
    ) {
        return null;
    }

    const selected = String(selectedSiteId);
    return siteIds.some((siteId) => String(siteId) === selected)
        ? selected
        : null;
}

export function isProgramSiteContextError(error) {
    return [
        'INVALID_SITE_CONTEXT',
        'SITE_NOT_FOUND',
        'SITE_ACCESS_FORBIDDEN',
    ].includes(error?.code);
}

export function isSameSiteSelection(currentSiteId, nextSiteId) {
    const normalize = (siteId) =>
        siteId === null || siteId === undefined || siteId === ''
            ? null
            : String(siteId);
    return normalize(currentSiteId) === normalize(nextSiteId);
}
